import { styled } from '@spazious/dollhouse-theme';

import {
  InputBase,
  InputBaseElement,
  InputBaseProps,
  InputBasePropsList,
} from '../InputBase/index.js';

export type InputTextElement = InputBaseElement;

export interface InputTextProps extends Omit<InputBaseProps, 'type'> {}

export const InputTextPropsList: (keyof InputTextProps)[] = InputBasePropsList.filter(
  (p) => p !== 'type'
) as (keyof InputTextProps)[];

export const InputText = styled(InputBase)
  .attrs({
    type: 'text',
  })
  .withConfig({
    displayName: 'InputText',
  })<InputTextProps>`
`;

export default InputText;
